<template>
  <el-card header="新建">
    <el-form :model="setting"
             :rules="rules"
             ref="ruleForm"
             label-position="right"
             label-width="80px"
    >

      <el-form-item label="配置名" prop="name">
        <el-input v-model="setting.name"></el-input>
      </el-form-item>
      <el-form-item label="key" prop="key">
        <el-input v-model="setting.key"></el-input>
      </el-form-item>
      <el-form-item label="value" prop="value">
        <el-input v-model="setting.value"></el-input>
      </el-form-item>
      <el-form-item label="组" prop="group">
        <el-input v-model="setting.group"></el-input>
      </el-form-item>
      <el-form-item label="是否隐藏" prop="hide">
        <el-switch
          v-model="setting.hide"
          :active-value="1"
          :inactive-value="0"
        ></el-switch>
      </el-form-item>
      <el-form-item label="类型" prop="type">
        <el-input v-model="setting.type"></el-input>
      </el-form-item>

      <el-form-item>
        <el-button type="primary" @click="settingCreate(setting)">创建</el-button>
        <el-button type="success" @click="backPage">返回</el-button>
      </el-form-item>
    </el-form>
  </el-card>
</template>

<script>
  import {mapState} from 'vuex'
  import back from '@/mixin/back'

  export default {
    name: "SettingCreate",
    mixins: [back],
    components: {},
    computed: {
      ...mapState({
        setting: state => state.setting.newSetting,
        rules: state => state.setting.rules,
        loading: state => state.setting.loading,
      }),
    },
    methods: {
      settingCreate(setting) {
        let vthis = this;
        this.$refs['ruleForm'].validate(validate => {
          if (!validate) {
            return;
          }
          this.$store.dispatch('setting/create', setting).then((res) => {
            vthis.$confirm('是否关闭此页面').then(_ => {
              vthis.$router.go(-1);
            }).catch(_ => {
            });
          })
        });
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/admin/setting/SettingCreate.vue